// Imported icons that can be used in ::before and ::after
import '../pseudo-font-awesome/css/all.min.css'

// CSS imports
import '../css/app.css';
import '../css/grid.css';
import '../css/shared.css';
import 'theme-css';
import '../css/breadcrumbs.css';
import '../css/account.css';
import '../css/read-more.css';
import '../css/blog.css';
import '../css/components.css';
import '../css/cart.css';
import '../css/navigation.css';
import '../css/notifications.css';
import '../css/mfp-overlay.css';
import '../css/helpie.css';
import '../css/swiper.css';
import '../css/product.css';
import '../css/product/listing.css';
import '../css/product/tiered-pricing.css';
import '../css/product/variants.css'
import '../css/product/tabs.css';
import '../css/product/sticky-add-to-cart.css';
import '../css/inputs.css';
import '../css/banner.css';
import '../css/flatsome.css';
import '../css/scrollbar.css';
import '../css/algolia.css';
import '../css/misc.css';
import '../css/teaser.css';
import '../css/product-bundle.css';
import './product-category/algolia/autocomplete.js'; 
import './product-category/algolia/drawer.js'

import { loadAlgolia } from './product-category/algolia.js';
import { loadBrandAlgolia } from './algolia/brand-search.js';
import { loadFontAwesome } from './global/fa-loader.js';
import { generateScrollbars } from './global/custom-scrollbar.js';
import { initializeElfbarCalculator } from './global/elfbar-calculator.js';
import { initializeMobileMenu } from './global/mobile-menu.js';
import { triggerMiniCart } from './global/trigger-minicart.js';
import { addWidgetClickHandler } from './global/trusted-shops.js';
import { generateTopbarSlider } from './global/topbar-slider.js';
import $, { waitForJQuery } from './jquery-shim.js';
import { updateDeliveryInfo } from './product/delivery-info.js';
import { initializeVariationDropdown } from './product/variation-dropdown.js';
import { ajaxAddToCartHandler } from './product-category/add-to-cart-handler.js';
import { listenToStickyFilter } from './product-category/sticky-filter.js';
import { toggleAccordion } from './global/accordion.js';
import { generateStickyTableOfContent } from './blog/table-of-content.js';
import { loadComments } from './blog/load-comments.js';
import { modelSwiper } from './product-category/model-swiper.js'; 
import { reviewSwiper } from './product-category/review-swiper.js'; 
import { paAlternativesSwiper } from './product/pa-alternatives-swiper.js';
import { loadCartIcon } from './global/cart-icon-loader.js';
import { loadProductSwiper } from './product/gallery.js';
import { loadRelatedProducts } from './product/related-products.js';
import { loadSimilarProductsSwiper } from './product/similar-products-swiper.js';
import { initializeTierPricing } from './product/tier-pricing.js';
import { initializeProductBundle } from './product-bundle/index.js';

//These scripts load instantly before any user interaction
loadCartIcon();
loadAlgolia();
loadBrandAlgolia();
loadProductSwiper();
loadRelatedProducts();
initializeProductBundle();
paAlternativesSwiper();
// These scripts load after a user interaction and are fired delayed
waitForJQuery().then(($) => {
  $(async function () {
    modelSwiper();
    reviewSwiper();
    loadFontAwesome();
    initializeMobileMenu();
    generateScrollbars();
    initializeVariationDropdown();
    // initializeImageNavigation();
    addWidgetClickHandler();
    updateDeliveryInfo();
    generateTopbarSlider();
    listenToStickyFilter();
    ajaxAddToCartHandler();
    toggleAccordion();
    initializeElfbarCalculator();
    triggerMiniCart();
    generateStickyTableOfContent();
    loadComments();
    initializeTierPricing();
    loadRelatedProducts();
    loadSimilarProductsSwiper();
  });
});

